import { useMutation } from '@tanstack/react-query';
import { createParkingContract } from '../../api/parking-contract.ts';
import type { CreateParkingContractRequest } from '../../api/requests/parking-contract-request.ts';

export default function useCreateParkingContract() {
  return useMutation<string, Error, CreateParkingContractRequest>({
    mutationFn: async (req) => {
      const response = await createParkingContract(req);
      return response.data.id;
    },
  });
}
